export const isCalcfocusPolicy = (policy) => {
  return policy?.sourceSystemName?.toUpperCase().includes("CALCFOCUS");
};
